'use client';

import { useState, useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../utils/constants';
import auth from '../../Auth';
import { Circle, Loader2 } from 'lucide-react';
import Breadcrumbs from '../Breadcrumbs';
import { Table, TableBody, TableColumn, TableHeader, TableRow, TableCell, Button, Pagination } from '@nextui-org/react';


const VersionImprovements = () => {
  const { prompt_id, prompt_version } = useParams();

  const [promptImprovements, setPromptImprovements] = useState([])
  const [isFetchedImprovements, setIsFetchedImprovements] = useState(false)

  const fetchVersionImprovements = async () => {
      await axios.get(`${API_URL}/tests?getVersionImprovements&prompt_id=${prompt_id}&prompt_version=${prompt_version}`, {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`
        }
      }).then((res) => {
        setPromptImprovements(res.data)
        console.log(res.data)
      }).catch((err) => console.error(err))
      setIsFetchedImprovements(true)
  }

  // 2. fetch prompt data with version or timestamp from logs
  useEffect(() => {
    fetchVersionImprovements()
    const intervalId = setInterval(fetchVersionImprovements, 60_000);

    return () => clearInterval(intervalId);
  }, []);

  const crumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: `/tests`, breadcrumb: 'CI/CD' },
    { path: `/tests/${prompt_id}`, breadcrumb: `${prompt_id}` },
    { path: window.location.href, breadcrumb: `${prompt_version}` }
  ];

  return (
    <div className='flex flex-col w-full p-8 space-y-8'>
    <Breadcrumbs crumbs={crumbs} />
        <div className='w-full'>
        {isFetchedImprovements ? 
            <>
            <h2 className='font-bold mb-4 text-xl'>Improvements of prompt {prompt_version}</h2>
            <Table isHeaderSticky className='max-h-[30vw]' aria-label='Prompt Library Table'>
            <TableHeader>
                <TableColumn>New version</TableColumn>
                <TableColumn>Suggested prompt</TableColumn>
            </TableHeader>
            <TableBody>
                {promptImprovements.map((improvement, index) => (
                <TableRow>
                    <TableCell>{improvement.new_prompt_version}</TableCell>
                    <TableCell>{JSON.stringify(improvement.improvement.suggested_prompt)}</TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table> </> : <Loader2 className='m-auto mt-3 animate-spin' />
            }
            </div>
    </div>
  );
};

export default VersionImprovements;
